import { Option, OptionGroup, Options, Value } from "../types";

export function isOptionsGroup(arg: Option | OptionGroup): arg is OptionGroup {
  return (arg as OptionGroup).options !== undefined;
}

export function flattenOptions(options: Options) {
  return options.reduce((acc: Value, optionOrGroup: Option | OptionGroup) => {
    if (isOptionsGroup(optionOrGroup)) {
      return [...acc, ...optionOrGroup.options];
    } else {
      return [...acc, optionOrGroup];
    }
  }, []);
}
